import "@/App.css";
import { SiteHeader } from "@/components/SiteHeader";
import { HeroSection } from "@/components/HeroSection";
import { RecognitionSection } from "@/components/RecognitionSection";
import { ApproachSection } from "@/components/ApproachSection";
import { CommunitySection } from "@/components/CommunitySection";
import { HomeShakthiSection, FinalInvitationSection } from "@/components/JourneySection";
import { FounderSection } from "@/components/FounderSection";
import { ContactSection } from "@/components/ContactSection";
import { SiteFooter } from "@/components/SiteFooter";
import { PageMeta } from "@/components/PageMeta";
import StartHerePage from "@/pages/StartHerePage";
import TermsPage from "@/pages/TermsPage";
import { siteContent } from "@/data/siteContent";

const HomePage = () => (
  <div className="site-shell" data-testid="academy-homepage">
    <PageMeta {...siteContent.homeMeta} />
    <a className="skip-link" href="#main-content" data-testid="skip-to-content-link">Skip to content</a>
    <SiteHeader />
    <main id="main-content" data-testid="homepage-main-content">
      <HeroSection />
      <RecognitionSection />
      <ApproachSection />
      <CommunitySection />
      <HomeShakthiSection />
      <FounderSection />
      <ContactSection />
      <FinalInvitationSection />
    </main>
    <SiteFooter />
  </div>
);

function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/start-here") return <StartHerePage />;
  if (path === "/terms_and_conditions") return <TermsPage />;
  if (path !== "/") {
    window.location.replace("/");
    return null;
  }
  return <HomePage />;
}

export default App;